export { default as Fade } from './Fade';
export { default as ScaleFade } from './ScaleFade';
export { default as Slide } from './Slide';
export { default as SlideFade } from './SlideFade';
export type {
  IFadeProps,
  IScaleFadeProps,
  ISlideProps,
  ISlideFadeProps,
} from './props';
